import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'itemOrders';
export const itemOrdersActions = makeActions(
  MODEL_NAME,
  'id',
  'transfer-orders',
);

export const getAllItemOrders = itemOrdersActions.getAll;
export const editItemOrders = itemOrdersActions.edit;
export const createItemOrders = itemOrdersActions.create;
export const getByIdItemOrders = itemOrdersActions.getDataById;
